// Heli Pirn KV2002
import React from "react";
import {
   CommonRows, F1Row, GirthRow, InputRangeRow, ItineraryTraverseRow, LengthRow,
   RunTimeRow, TypeRow, WindingTensionRow
} from "./index";

export default function MachineHeliPirn() {
   return (
      <>
         <RunTimeRow />
         <LengthRow />
         <GirthRow />
         <F1Row />
         <TypeRow />
         <InputRangeRow
            titleProp={"Spindle Setup/Speed"}
            descriptionProp={"rpm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={555.3}
            propertyNameProp={"spindleSpeed"}
            errorDialogueProp={"0-5,925 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Ring Plate/Traverse Speed"}
            descriptionProp={"mm/sec"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={555.3}
            propertyNameProp={"traverseSpeed"}
            errorDialogueProp={"0.00-553.5 only"}
            floatProp={true}
         />
         <ItineraryTraverseRow />
         <InputRangeRow
            titleProp={"Starting Pos"}
            descriptionProp={"mm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={555.3}
            propertyNameProp={"startPos"}
            errorDialogueProp={"0.00-553.5 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Cycle Variable"}
            descriptionProp={"mm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={55.3}
            propertyNameProp={"cycleVariable"}
            errorDialogueProp={"0.00-53.5 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Bottom Trim"}
            descriptionProp={"/20"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={35}
            propertyNameProp={"bottomTrim"}
            errorDialogueProp={"0-35 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Trim Amount"}
            descriptionProp={"mm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={0}
            maxProp={55.3}
            propertyNameProp={"trimAmount"}
            errorDialogueProp={"0.00-53.5 only"}
            floatProp={true}
         />
         <WindingTensionRow differentTitle={"Spindle Tension"} />
         <CommonRows />
      </>
   );
}
